<template>
  <div class="main-body">
    <div class="header">活动分类</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

            <el-table-column prop="name" label="类型"  fixed></el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              </template>
            </el-table-column>

          </el-table>

      <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,


      // options: [{
      //     value: -1,
      //     label: '全部状态'
      // }, {
      //     value: 0,
      //     label: '默认'
      // }, {
      //     value: 1,
      //     label: '已通过'
      // }, {
      //     value: 2,
      //     label: '被禁用'
      // }],
      status: -1,


      showModalAdd:false,
      showModalEdit:false,
      roleList:null,
      editStaff:null,

      th:0,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    roleNames(){
      return '管理员'
    },
    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityClass/Page',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    changeStatus:function(selVal){
      this.status = selVal;
    },


    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    handleDelete(index, row) {
      console.log(index, row);
    },


    statusTitle(row){
      if(row.status == 0){
        return "默认";
      }
      if(row.status == 1){
        return "已通过";
      }
      if(row.status == 2){
        return "被禁用";
      }
      return "其它";
    },


  }
}
</script>

<style scoped>

</style>
